import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=0c77337e&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=0c77337e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c77337e",
  null
  
)

export default component.exports